import {StageManager} from "../StageMaganer/StageManager";
import {PublicTicketsFormDefs} from "../PublicTicketsForm";

class GlobalState {
    /** @var {PublicTicketsFormDefs.Stage[]} */
    stageArray;
    /** @var {StageManager} */
    stageManager;
    /** @var {PublicTicketsFormDefs.Stage} */
    currentStage;

    /** @var {PublicEventResource.PublicEventResource|undefined} */
    parentEvent;

    /** @var {PublicEventResource.PublicEventResource|undefined} */
    selectedDate

    /** @var {PublicEventResource.SeatType} */
    selectedSeatType

    /** @var {PublicTicketsFormDefs.ReservedSeatSelection[]} */
    selectedSeats

    /** @var {PublicTicketsFormDefs.SectionTicketCount[]} */
    generalAdmissionTicketCounts
    /** @var {PublicTicketsFormDefs.SectionTicketCount[]} */
    reserveTicketCounts

    /** @var {string} */
    discountCode

    /** @var {PublicTicketsFormDefs.Addon[]} */
    addons

    /** @var {PublicTicketsFormDefs.PaymentInfo} */
    paymentInfo

    /** @var {string} */
    howDidYouFindUs


    constructor() {
        // Initial state
        this.stageArray = [
            'show-select',
            'date-select',
            'seat-select',
            'seat-type-select',
            'payment-info',
            'summary',
        ];

        this.selectedSeatType = undefined;
        this.selectedSeats = [];
        this.generalAdmissionTicketCounts = [];
        this.reserveTicketCounts = [];
        this.discountCode = '';
        this.addons = [];

        this.howDidYouFindUs = '';

        this.currentStage = 'show-select';

        // Stage Manager
        this.stageManager = this.getInitialStageManage();
    }

    getInitialStageManage() {
        return new StageManager(this);
    }

    hasRecordChanged(originalRecord, newRecord, fieldToCheck = 'id') {
        // If either of them is null but the other isn't, we know it has changed
        if (!originalRecord && newRecord) {
            return true;
        }
        if (originalRecord && !newRecord) {
            return true;
        }

        // If both records are equal, then either both are empty and nothing changed, or they are
        // strict match which means neither has changed too.
        if (originalRecord === newRecord) {
            return false;
        }

        // Finally, both must be defined and not a strict match, compare by given field
        return !(originalRecord[fieldToCheck] === newRecord[fieldToCheck]);
    }

    /**
     * @param {PublicEventResource.PublicEventResource} parentEvent
     */
    setParentEvent(parentEvent) {
        // Check if we selected a different parent event
        const recordChanged = this.hasRecordChanged(
            this.parentEvent,
            parentEvent
        );

        // Update in memory
        this.parentEvent = parentEvent

        // Clear next stage if required
        if (recordChanged) {
            this.stageManager.clearStageInstance('date-select');

            this.selectedDate = undefined;
        }
    };


    /**
     * @param {PublicEventResource.PublicEventResource} eventDate
     */
    setEventDate(eventDate) {
        // Check if we selected a different event date
        const recordChanged = this.hasRecordChanged(
            this.selectedDate,
            eventDate
        );

        // Update in memory
        this.selectedDate = eventDate;

        // Clear next stage if required
        if (recordChanged) {
            // Clear seat type
            this.selectedSeatType = undefined;
        }
    }

    /**
     * @param {PublicEventResource.SeatType} seatType
     */
    setSeatType(seatType) {
        // Check if we selected a different seat type
        const recordChanged = this.hasRecordChanged(
            this.selectedSeatType,
            seatType
        );

        // Update in memory
        // noinspection JSValidateTypes
        this.selectedSeatType = seatType;

        // Clear next stage if required
        if (recordChanged) {
            // Clear next stage if seat was changed
            this.stageManager.clearStageInstance('seat-select');
            this.stageManager.clearStageInstance('seat-type-select');
            this.stageManager.clearStageInstance('summary');
        }
    }

    /**
     * Save the order id generated from the server
     *
     * @param {string} orderId
     */
    setOrderId(orderId) {
        this.orderId = orderId;
    }

    /**
     * @param {PublicTicketsFormDefs.ReservedSeatSelection[]} seats
     */
    setSelectedSeats(seats) {
        this.selectedSeats = seats;

        // TODO: check if seats were truly changed

        this.stageManager.clearStageInstance('seat-type-select');
    }

    /**
     * @param {PublicTicketsFormDefs.SectionTicketCount[]} tickets
     */
    setGeneralAdmissionTicketCounts(tickets) {
        this.generalAdmissionTicketCounts = tickets;

        // TODO: Check if ticket counts were truly changed

        this.stageManager.clearStageInstance('payment-info');
        this.stageManager.clearStageInstance('summary');
    }

    /**
     * @param {PublicTicketsFormDefs.SectionTicketCount[]} tickets
     */
    setReserveTicketCounts(tickets) {
        this.reserveTicketCounts = tickets;

        // TODO: Check if ticket counts were truly changed

        this.stageManager.clearStageInstance('payment-info');
        this.stageManager.clearStageInstance('summary');
    }

    /**
     * @param {PublicTicketsFormDefs.Addon[]} addons
     */
    setAddons(addons) {
        this.addons = addons;

        // TODO: Check if addons were truly changed

        this.stageManager.clearStageInstance('payment-info');
        this.stageManager.clearStageInstance('summary');
    }

    /**
     * @param {string} discountCode
     */
    setDiscountCode(discountCode) {
        this.discountCode = discountCode;

        // TODO: Check if discount code was truly changed

        this.stageManager.clearStageInstance('payment-info');
        this.stageManager.clearStageInstance('summary');
    }

    /**
     * @param {PublicTicketsFormDefs.PaymentInfo} paymentInfo
     */
    setPaymentInfo(paymentInfo) {
        this.paymentInfo = paymentInfo;

        // TODO: Check if payment info was truly changed

        this.stageManager.clearStageInstance('summary');
    }

    /**
     * @param {string} howDidYouFindUs
     */
    setHowDidYouFindUs(howDidYouFindUs) {
        this.howDidYouFindUs = howDidYouFindUs;
    }

    /**
     * Returns order data in a format the server can understand
     */
    getOrderDataForServer(useRealPaymentData = false) {
        // Build reserved seats array
        let reserved_seats = undefined;

        if (this.selectedSeats.length) {
            reserved_seats = this.selectedSeats;
        }


        // Build seats array
        const seats = [];

        this.generalAdmissionTicketCounts.forEach(seatCount => {
            seats.push({
                seat_group_id: seatCount.groupId,
                visitor_type: seatCount.visitorTypeId,
                quantity: seatCount.count,
            });
        })
        this.reserveTicketCounts.forEach(seatCount => {
            seats.push({
                seat_group_id: seatCount.groupId,
                visitor_type: seatCount.visitorTypeId,
                quantity: seatCount.count,
            });
        })


        // Build addons array
        const addons = this.addons.map(addon => {
            return {
                addon_id: addon.addon_id,
                quantity: (addon.count === undefined) ? 1 : addon.count,
            };
        })

        let paymentInfo = this.paymentInfo;

        const discountsArray = this.discountCode ? [{code: this.discountCode}] : [];

        return {
            order_id: this.orderId,
            event_id: this.parentEvent.id,
            event_date_id: this.selectedDate.id,

            seats,
            addons,
            reserved_seats,

            ...paymentInfo,
            how_did_you_find_us: this.howDidYouFindUs,
            discounts: discountsArray,
        }
    }
}

export {GlobalState};
